// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {WarrantySimpleModal} from '../../../shared/components/modal';

const ConfirmationModal = props =>
    <section className='confirmation-modal'>
        <WarrantySimpleModal isOpen={props.isOpen}>
            <header>
                <FormattedMessage id={props.title}/>
            </header>
            <div className='modal-body'>
                <span className='confirm-message'>
                    <FormattedMessage id={props.confirmMessage}/>
                </span>
                <div className='button-group'>
                    <button onClick={props.onClose}>
                        <FormattedMessage id='NO'/>
                    </button>
                    <button
                        className='button-primary'
                        onClick={props.onConfirm}
                    >
                        <FormattedMessage id='YES'/>
                    </button>
                </div>
            </div>
        </WarrantySimpleModal>
    </section>;

ConfirmationModal.displayName = 'ConfirmationModal';
ConfirmationModal.propTypes = {
    confirmMessage: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/shared/components/confirmation-modal/index.js